import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import { contentErrorMessage } from "./contentError";
import generalLoginApiController from "services/generalLogin.service";

const generalLoginErrorMessage = (action, fallback) => contentErrorMessage(action, fallback);

export const GeneralLoginStoreApi = createAsyncThunk("generallogin/create", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await generalLoginApiController
      .create(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "create"))
      .catch((error) => HandleError(thunkAPI, error, "create"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const GeneralLoginDetailApi = createAsyncThunk("generallogin/view", async (formValues, thunkAPI) => {
  try {
    const resposedata = await generalLoginApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "generallogindetail"))
      .catch((error) => HandleError(thunkAPI, error, "generallogindetail"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  isGeneralLoginCreate: [],
  isGeneralLoginCreateError: "",
  isDetailData: "",
  isDetailDataError: "",
  isApiStatus: {
    GeneralLoginStoreApi: "",
    GeneralLoginDetailApi: "",
  }
}

export const generalloginSlice = createSlice({
  name: "generallogin",
  initialState,
  reducers: {
    reset: () => initialState,

  },
  extraReducers: (builder) => {
    builder
      .addCase(GeneralLoginStoreApi.pending, (state) => {
        state.isGeneralLoginCreateError = "";
        state.isApiStatus = { ...state.isApiStatus, GeneralLoginStoreApi: "loading" };
      })
      .addCase(GeneralLoginStoreApi.fulfilled, (state, action) => {
        if (state.isGeneralLoginCreate && state.isGeneralLoginCreate.data) {
          state.isGeneralLoginCreate.data = [action.payload, ...state.isGeneralLoginCreate.data];
        } else {
          state.isGeneralLoginCreate = { data: [action.payload] };
        }
        state.isApiStatus = { ...state.isApiStatus, GeneralLoginStoreApi: "succeeded" };
        state.isGeneralLoginCreateError = "";
      })
      .addCase(GeneralLoginStoreApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, GeneralLoginStoreApi: "failed" };
        state.isGeneralLoginCreateError = generalLoginErrorMessage(action, "Unable to save general login details.");
      })
      .addCase(GeneralLoginDetailApi.pending, (state) => {
        state.isDetailDataError = "";
        state.isApiStatus = { ...state.isApiStatus, GeneralLoginDetailApi: "loading" };
      })
      .addCase(GeneralLoginDetailApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, GeneralLoginDetailApi: "succeeded" };
        state.isDetailData = action.payload;
        state.isDetailDataError = "";
      })
      .addCase(GeneralLoginDetailApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, GeneralLoginDetailApi: "failed" };
        state.isDetailDataError = generalLoginErrorMessage(action, "Unable to load general login details.");
      })
  },
});

export const { reset } = generalloginSlice.actions;
export default generalloginSlice.reducer;
